import { useEffect, useRef, useState } from "react";
import useLocales from "src/hooks/useLocales";

const REQUIRED_FIELDS = [
  "idCardFrontDocument",
  "idCardBackDocument",
  "signatureDocument",
];

export const useLegalRepresentativeValidation = (
  complianceLegalRepresentative,
  documentNumberError,
  showComplianceLegalRepresentative = true,
  showDocumentNumberError = true,
) => {
  const { translate } = useLocales();
  const [error, setError] = useState<string[]>([]);
  const [isValid, setIsValid] = useState(false);
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    debounceTimerRef.current = setTimeout(() => {
      const errors: string[] = [];
      let isFormValid = true;

      if (showComplianceLegalRepresentative) {
        if (!complianceLegalRepresentative) {
          errors.push(
            translate(
              "please_provide_complete_legal_representative_information",
            ),
          );
          isFormValid = false;
        } else {
          const missingFields = REQUIRED_FIELDS.filter((field) => {
            const value = complianceLegalRepresentative[field];
            return !value || value === null || value === "";
          });

          if (missingFields.length > 0) {
            errors.push(
              translate(
                "please_provide_complete_legal_representative_information",
              ),
            );
            isFormValid = false;
          }
        }
      }

      if (showDocumentNumberError) {
        if (documentNumberError && documentNumberError.trim() !== "") {
          errors.push(documentNumberError);
          isFormValid = false;
        }
      }

      setError(errors);
      setIsValid(isFormValid);
    }, 1000);

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [
    complianceLegalRepresentative,
    translate,
    documentNumberError,
    showComplianceLegalRepresentative,
    showDocumentNumberError,
  ]);

  return { error, isValid };
};
